import React from "react";
import { Form } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import "./style.css";
import { dateConversion } from "../../../utils/formatDate";

interface SummaryOfAssessmentProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const SummaryOfAssessment: React.FC<SummaryOfAssessmentProps> = ({
  formData,
  setFormData,
}) => {


  return (
    <div className="summary-of-assessment p-4">
      <Table
        bordered
        size="sm"
        className="text-center align-middle summary-table"
        style={{ border: "#353535" }}
      >
        <tbody className="border-black">
          <tr>
            <td rowSpan={5}
              style={{
                width: "281px",
                background: "#E5E5E5",
                fontWeight: 800,
                color: "black",
              }}
              className="auditor-certification-recommendation">
              AUDITOR CERTIFICATION RECOMMENDATION
            </td>
          </tr>
          <tr>
            <td style={{ width: "144px", fontWeight: 800, color: "#353535" }} className="auditor-certification-header">FSC</td>
            <td>
              {formData.SummaryOfAssessment.Auditor_Certification_Review_FSC__c || "--"}
            </td>
            <td className="italic-text text-center">
              {formData.SummaryOfAssessment.Auditor_Comments_FSC__c || "--"}
            </td>
          </tr>
          <tr>
            <td className="auditor-certification-header">PEFC</td>
            <td>
              {formData.SummaryOfAssessment.Auditor_Certification_Review_PEFC__c ||
                "--"}
            </td>
            <td className="italic-text text-center">
              {formData.SummaryOfAssessment.Auditor_Comments_PEFC__c || "--"}
            </td>
          </tr>
          <tr>
            <td className="auditor-certification-header">SFI</td>
            <td>
              {formData.SummaryOfAssessment.Auditor_Certification_Review_SFI__c || "--"}
            </td>
            <td className="italic-text text-center">
              {formData.SummaryOfAssessment.Auditor_Comments_SFI__c || "--"}
            </td>
          </tr>
          <tr>
            <td className="auditor-certification-header">Other</td>
            <td>
              {formData.SummaryOfAssessment.Auditor_Certification_Review_Other__c ||
                "--"}
            </td>
            <td className="italic-text text-center">
              {formData.SummaryOfAssessment.Auditor_Comments_Other__c || "--"}
            </td>
          </tr>
        </tbody>
      </Table>

      <div className="table-container">
        <Table
          bordered
          size="sm"
          className="text-center align-middle summary-table"
        >
          <tbody className="border-black">
            <tr>
              <td rowSpan={6} className="certification-decision">
                <p className="decision-title">CERTIFICATION DECISION</p>
                <span className="scs-use"> (SCS use only)</span>
              </td>
            </tr>
            <tr>
              <td  className="auditor-certification-header">FSC</td>
              <td className="text-left">
                {formData.SummaryOfAssessment.SCS_Certification_Decision_FSC__c || "--"}
              </td>
              <td colSpan={3} className="italic-text text-center">
                {formData.SummaryOfAssessment.SCS_Decision_Comments_FSC__c || "--"}
              </td>
            </tr>
            <tr>
              <td className="auditor-certification-header">PEFC</td>
              <td className="text-left">
                {formData.SummaryOfAssessment.SCS_Certification_Decision_PEFC__c || "--"}
              </td>
              <td colSpan={3} className="italic-text text-center">
                {formData.SummaryOfAssessment.SCS_Decision_Comments_PEFC__c || "--"}
              </td>
            </tr>
            <tr>
              <td className="auditor-certification-header">SFI</td>
              <td className="text-left">
                {formData.SummaryOfAssessment.SCS_Certification_Decision_SFI__c || "--"}
              </td>
              <td colSpan={3} className="italic-text text-center">
                {formData.SummaryOfAssessment.SCS_Decision_Comments_SFI__c || "--"}
              </td>
            </tr>
            <tr>
              <td className="auditor-certification-header">Other</td>
              <td className="text-left">
                {formData.SummaryOfAssessment.SCS_Certification_Decision_Other__c || "--"}
              </td>
              <td colSpan={3} className="italic-text text-center">
                {formData.SummaryOfAssessment.SCS_Decision_Comments_Other__c || "--"}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <Form.Label className="assesment-form-label">
                  Certification decision(s) by
                </Form.Label>
                <span className="date-text">
                  {formData.SummaryOfAssessment.Certification_Decision_s_By__c ||
                    "--"}
                </span>
              </td>

              <td colSpan={2}>
                <Form.Label className="assesment-form-label">
                  Date of report finalization
                </Form.Label>
                <span className="date-text">
                  {formData.SummaryOfAssessment.Date_Of_Report_Finalization__c ? dateConversion(formData.SummaryOfAssessment.Date_Of_Report_Finalization__c, "DD MMM YYYY") :
                    "--"}
                </span>
              </td>
            </tr>

            <tr>
              <td colSpan={2} className="allowable-size-container">
                <div className="allowable-size-label">
                  Allowable size limit and annual growth rate (FSC only):
                  <span className="growth-rate">
                    {" "}
                    {formData.SummaryOfAssessment.Certificate_Type__c || "--"}
                  </span>
                </div>
              </td>

              <td colSpan={4} className="allowable-size-details">
                <div className="d-flex">
                  The organization may add up to{" "}
                  {formData.SummaryOfAssessment.Allowable_Size_Limit__c || "--"} sites
                  to the certificate before the next annual audit (
                  {formData.SummaryOfAssessment.Annual_growth_rate__c || "--"} %
                  growth).*
                  <br />
                  This number is subject to change at subsequent SCS audits.
                </div>
                {formData.SummaryOfAssessment.Central_Office_Audit_Program__c && (
                  <Form.Check
                    type="checkbox"
                    id="na-checkbox"
                    disabled
                    label="N/A, no Central Office Audit Program; all sites must be audited by SCS before being added to the certificate."
                    defaultChecked={true}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default SummaryOfAssessment;
